import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_call-capture-ai-1/artifacts/4yf2lu9l_Black%20%26%20Beige%20Modern%20Typography%20Monogram%20Logo%20%283%29.png";
const TRIAL_URL = "https://6vmun24i.forms.app/plumbing-lead-qualification-form";
const DEMO_URL = "https://cal.com/noah-velocitylabs";

const navLinks = [
  { label: "How It Works", href: "#how-it-works" },
  { label: "Results", href: "#results" },
  { label: "Pricing", href: "#pricing" },
  { label: "Team", href: "#team" },
];

export default function Navbar() {
  return (
    <motion.nav
      data-testid="navbar"
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className="fixed top-0 left-0 right-0 z-50 bg-[#0A0A0A]/70 backdrop-blur-xl border-b border-white/[0.06]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-16">
        <a href="#hero" data-testid="navbar-logo" className="flex items-center gap-2">
          <img
            src={LOGO_URL}
            alt="Velocity Labs"
            className="h-8 w-auto invert brightness-200"
          />
        </a>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm text-[#A3A3A3] hover:text-white transition-colors duration-200 font-medium"
              style={{ fontFamily: "Manrope, sans-serif" }}
            >
              {link.label}
            </a>
          ))}
        </div>

        <a
          href={DEMO_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="navbar-cta-demo"
          className="group flex items-center gap-2 bg-[#5B8DEF] hover:bg-[#4A79D3] text-white text-sm font-semibold px-5 py-2.5 rounded-lg transition-all duration-200 active:scale-95"
          style={{ fontFamily: "Manrope, sans-serif" }}
        >
          Book a Demo
          <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform duration-200" />
        </a>
      </div>
    </motion.nav>
  );
}
